import {
  CLEAR_CURRENT_PROFILE,
  GET_PROFILE,
  PROFILE_LOADING,
  GET_PROFILES,
  GET_ADVISORS,
  GET_ADMINS,
  GET_TUTORS,
  ADVISOR_PROFILE_LOADING,
} from '../actions/types';

const initialState = {
  profile: null,
  profiles: null,
  advisors: null,
  admins: null,
  tutors: null,
  loading: false,
  advisorloading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADVISOR_PROFILE_LOADING:
      return {
        ...state,
        advisorloading: true,
      };
    case PROFILE_LOADING:
      return {
        ...state,
        loading: true,
      };
    case GET_PROFILE:
      return {
        ...state,
        profile: action.payload,
        profiles: null,
        loading: false,
      };
    case CLEAR_CURRENT_PROFILE:
      return {
        ...state,
        profile: null,
        profiles: null,
      };
    case GET_PROFILES:
      return {
        ...state,
        profile: null,
        profiles: action.payload,
        loading: false,
      };
    case GET_ADVISORS:
      return {
        ...state,
        advisors: action.payload,
        advisorloading: false,
      };
    case GET_ADMINS:
      return {
        ...state,
        admins: action.payload,
        loading: false,
      };
    case GET_TUTORS:
      return {
        ...state,
        tutors: action.payload,
        loading: false,
      };
    default:
      return state;
  }
}
